import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";
import { UsersBalanceReportEntry } from "@/model/data/usersBalance/UsersBalanceReportEntry";
import { UsersBalanceReportTotals } from "@/model/data/usersBalance/UsersBalanceReportTotals";

export class GetUsersBalanceReportResData extends ServiceResponseData {
    availableGroups: CaosGroup[] = [];
    availableShiftNumbers: string[] = [];
    usersBalanceReportEntries: UsersBalanceReportEntry[] = [];
    usersBalanceReportTotals: UsersBalanceReportTotals;
    analizedTransactionsCount: number = 0;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.AvailableGroups && obj.AvailableGroups.length > 0) {
            this.availableGroups = [];
            obj.AvailableGroups.forEach((group) => {
                var g = new CaosGroup();
                g.parse(group);
                this.availableGroups.push(g);
            });
        }

        if (obj.AvailableShiftNumbers && obj.AvailableShiftNumbers.length > 0) {
            this.availableShiftNumbers = [];
            obj.AvailableShiftNumbers.forEach((shift) => {
                this.availableShiftNumbers.push(shift);
            });
        }

        if (obj.UsersBalanceReportEntries && obj.UsersBalanceReportEntries.length > 0) {
            this.usersBalanceReportEntries = [];
            obj.UsersBalanceReportEntries.forEach((obj) => {
                var temp = new UsersBalanceReportEntry();
                temp.parse(obj);
                this.usersBalanceReportEntries.push(temp);
            });
        }

        if (obj.UsersBalanceReportTotals) {
            var temp = new UsersBalanceReportTotals();
            temp.parse(obj.UsersBalanceReportTotals);
            this.usersBalanceReportTotals = temp;
        }

        if (obj.AnalizedTransactionsCount != null) this.analizedTransactionsCount = obj.AnalizedTransactionsCount;
    }
}

export class CaosGroup {
    id: number;
    name: string;

    parse(obj: any) {
        if (obj.Id != null) this.id = obj.Id;
        if (obj.Name != null) this.name = obj.Name;
    }
}
